import { useContext } from "react";

import { OrganizationContext } from "./OrganizationContext";

export const useOrganizationContext = () => useContext(OrganizationContext);
